import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import params from '../../../../utils/routing/params'
import notificationsUtils from '../../../../utils/notifications/notificationsUtils'
import renderTextInputWithFeedback from '../../../../components/ui/forms/renderTextInputWithFeedback'
import formValidators from '../../../../utils/validation/formValidators'
import * as resetPasswordDuck from '../resetPasswordDuck'

class ResetPasswordForm extends Component {
  render() {
    const { handleSubmit, pristine, invalid } = this.props

    return (
      <div className="row">
        <div className="col-xs-12 max-800">
          <form>
            <Field
              component={renderTextInputWithFeedback}
              name="password"
              placeholder="New Password"
              type="password"
            />
            <button
              onClick={handleSubmit}
              className="btn btn-block btn-success"
              disabled={pristine || invalid}
            >
              Save
            </button>
          </form>
        </div>
      </div>
    )
  }
}

ResetPasswordForm.propTypes = {
  invalid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  clearResetPassword: PropTypes.func.isRequired,
  performResetPassword: PropTypes.func.isRequired,
}

ResetPasswordForm.defaultProps = {}


/**
 * @const validate
 * @desc Checks whether our form is valid
 * @param values
 * @returns {{}}
 */
const validate = values => {
  const errors = {}
  errors.password = formValidators.isRequired(values.password)
  return errors
}

/**
 * @const wrappedWithForm
 * @desc Gives ForgotPasswordForm extra props like invalid, pristine, and handleSubmit
 */
const wrappedWithForm = reduxForm({
  form: 'resetPasswordForm',
  onSubmit: async (values, _dispatch, props) => {
    try {
      const { passwordResetToken } = params.getParamObject(props.location.search)

      const resetToken = passwordResetToken && passwordResetToken[0] ?
        passwordResetToken[0] :
        ''

      await props.performResetPassword(Object.assign(
        {},
        values,
        { passwordResetToken: resetToken },
      ))
      notificationsUtils.showSuccessNotification('Password Reset Successfully! Log in with your new password.')
      props.clearResetPassword()
      props.history.push('/login')
    } catch (error) {
      notificationsUtils.showErrorNotification(error.message)
    }
  },
  validate,
})(ResetPasswordForm)


const wrappedWithRouter = withRouter(wrappedWithForm)


/**
 * @const mapStateToProps
 * @desc Grabs branch "forgotPassword" from Redux state and makes it accessible as this.props.forgotPassword
 * @param state
 */
const mapStateToProps = state => ({
  resetPassword: state.resetPassword,
})


/**
 * @const mapDispatchToProps
 * @desc Binds an Action Performer to this.props
 * @param dispatch
 */
const mapDispatchToProps = dispatch =>
  bindActionCreators({
    clearResetPassword: resetPasswordDuck.clearResetPassword,
    performResetPassword: resetPasswordDuck.performResetPassword,
  }, dispatch)


export default connect(mapStateToProps, mapDispatchToProps)(wrappedWithRouter)



// WEBPACK FOOTER //
// ./src/routes/unauthenticated/ResetPassword/components/ResetPasswordForm.js